import { ReactComponent as PendingIcon } from '@basqet-dashboard/common/assets/icons/warning.svg';
import { Button } from '@basqet-dashboard/common/components';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import React from 'react';

const KycPending = () => {
  const { navigateTo } = useNavigateTo();
  return (
    <div className="kyc__status">
      <div className="card kyc__status--pending  text-center">
        <PendingIcon />
        <header className="card__header">
          <h3>Submission Received</h3>
          <p>
            Your documents have been submitted and our team is reviewing them. You will receive an
            update within 3 working days. You can run test transactions, but live transaction are
            disabled until KYB is approved.
          </p>
        </header>
        <Button isFull onClick={() => navigateTo('/')}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export { KycPending };
